var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c("div", { staticClass: "single container-max page-content mb-4" }, [
            _c("div", { staticClass: "row position-relative" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-6 mt-md-5 px-0 px-md-3 position-relative"
                },
                [
                  _vm._t("image-carousel"),
                  _vm._v(" "),
                  _vm.savingMoneyPercent > 0 || _vm.campaignBadgeValue
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "fs-tag-row fs-tag-row-mobile d-flex align-items-center d-md-none"
                        },
                        [
                          _vm.savingMoneyPercent > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-discount-badge bg-danger border-radius px-3 py-2 font-weight-bold d-inline-flex align-items-center justify-content-center mr-2"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "-" +
                                        _vm._s(
                                          Math.floor(_vm.savingMoneyPercent)
                                        ) +
                                        "%"
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.campaignBadgeValue
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-campaign-badge border-radius px-3 py-2 text-uppercase font-weight-bold d-inline-flex align-items-center"
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.campaignBadgeValue))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.savingMoneyPercent > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "fs-saving d-none bg-danger text-white border-radius p-2 position-absolute"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "-" +
                                _vm._s(Math.floor(_vm.savingMoneyPercent)) +
                                "%"
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variationProperties &&
                  _vm.currentVariation.variationProperties.length > 0
                    ? _vm._l(_vm.getBadgeProperties, function(
                        variationPropertyGroups
                      ) {
                        return _c(
                          "div",
                          { key: variationPropertyGroups.id },
                          _vm._l(variationPropertyGroups.properties, function(
                            badgeProperty
                          ) {
                            return _c(
                              "div",
                              { key: badgeProperty.id },
                              [
                                badgeProperty.id === 266
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "fs-badge position-absolute"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "img-fluid",
                                            attrs: {
                                              src: _vm.$translate(
                                                "HuGVueTheme::SingleItemTheme.BadgeImg"
                                              ),
                                              alt: _vm.$translate(
                                                "HuGVueTheme::SingleItemTheme.BadgeAltText"
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          0
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variationProperties &&
                  _vm.currentVariation.variationProperties.length > 0
                    ? _vm._l(_vm.getVideoProperties, function(
                        variationPropertyGroups
                      ) {
                        return _c("div", { key: variationPropertyGroups.id }, [
                          _c("button", {
                            staticClass:
                              "btn btn-primary fs-video-btn border-radius font-weight-bold align-items-center d-none d-md-inline-flex mt-2",
                            attrs: {
                              type: "button",
                              "data-toggle": "modal",
                              "data-target": "#product-video"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "HuGVueTheme::SingleItemTheme.ModalButtonText"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "modal fade",
                              attrs: {
                                id: "product-video",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "product-video",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog",
                                  attrs: { role: "document" }
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _c("div", { staticClass: "modal-header" }, [
                                      _c("p", {
                                        staticClass: "modal-title h5",
                                        attrs: { id: "product-video-label" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "HuGVueTheme::SingleItemTheme.ModalHeadline"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._m(0, true)
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "modal-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "container-max px-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row" },
                                            _vm._l(
                                              variationPropertyGroups.properties,
                                              function(variationProperty) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: variationProperty.id,
                                                    staticClass:
                                                      "col-12 col-md-6 mb-3"
                                                  },
                                                  [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          controls: "",
                                                          poster: _vm.$translate(
                                                            "HuGVueTheme::SingleItemTheme.ModalDefaulImage"
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src:
                                                              variationProperty
                                                                .values.value,
                                                            type: "video/mp4"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "modal-footer" }, [
                                      _c("button", {
                                        staticClass: "btn btn-secondary",
                                        attrs: {
                                          type: "button",
                                          "data-dismiss": "modal"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "HuGVueTheme::SingleItemTheme.ModalClose"
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      })
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-6 mt-md-5 px-0 px-md-3" },
                [
                  _c(
                    "div",
                    [
                      _vm.savingMoneyPercent > 0 || _vm.campaignBadgeValue
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "fs-tag-row d-none d-md-flex align-items-center px-3 px-md-0 mt-3 mt-md-0 mb-2"
                            },
                            [
                              _vm.savingMoneyPercent > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-discount-badge bg-danger border-radius px-3 py-2 font-weight-bold d-inline-flex align-items-center justify-content-center mr-2"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              Math.floor(_vm.savingMoneyPercent)
                                            ) +
                                            "%"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.campaignBadgeValue
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-campaign-badge border-radius px-3 py-2 text-uppercase font-weight-bold d-inline-flex align-items-center"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.campaignBadgeValue))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass:
                            "h4 title font-weight-bold mt-3 mt-lg-0 mb-2 px-3 px-md-0 pt-3 pt-md-0",
                          attrs: { "data-testing": "item-name" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("itemName")(_vm.currentVariation))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "fs-rating-row d-flex align-items-center px-3 px-md-0 mb-3"
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "HuGVueTheme::SingleItemTheme.RatingText"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buy-box pt-4 p-3 border-radius" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "single-usp d-flex w-100 justify-content-between align-items-center"
                            },
                            [
                              _vm._t("fs-usps", [
                                _c("ul", { staticClass: "list-unstyled m-0" }, [
                                  _c("li", [
                                    _c("span", {
                                      staticClass:
                                        "font-weight-bold text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "HuGVueTheme::SingleItemTheme.Usp1"
                                          )
                                        )
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", {
                                      staticClass:
                                        "font-weight-bold text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "HuGVueTheme::SingleItemTheme.Usp2"
                                          )
                                        )
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", {
                                      staticClass:
                                        "font-weight-bold text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "HuGVueTheme::SingleItemTheme.Usp3"
                                          )
                                        )
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _vm.isUsp4Visible
                                    ? _c("li", [
                                        _c("span", {
                                          staticClass:
                                            "d-none font-weight-bold text-center",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$translate(
                                                "HuGVueTheme::SingleItemTheme.Usp4"
                                              )
                                            )
                                          }
                                        })
                                      ])
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "manufacturer ml-auto" },
                                [
                                  _vm.currentVariation.filter.hasManufacturer
                                    ? [
                                        _vm.currentVariation.item.manufacturer
                                          .url != ""
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    _vm.currentVariation.item
                                                      .manufacturer.url
                                                }
                                              },
                                              [
                                                _vm.currentVariation.item
                                                  .manufacturer.logo != ""
                                                  ? _c("img", {
                                                      staticClass: "img-fluid",
                                                      attrs: {
                                                        alt:
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .externalName,
                                                        src:
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .logo,
                                                        width: "120"
                                                      }
                                                    })
                                                  : _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .externalName
                                                        )
                                                      }
                                                    })
                                              ]
                                            )
                                          : [
                                              _vm.currentVariation.item
                                                .manufacturer.logo != ""
                                                ? _c("img", {
                                                    staticClass: "img-fluid",
                                                    attrs: {
                                                      alt:
                                                        _vm.currentVariation
                                                          .item.manufacturer
                                                          .externalName,
                                                      src:
                                                        _vm.currentVariation
                                                          .item.manufacturer
                                                          .logo,
                                                      width: "120"
                                                    }
                                                  })
                                                : _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.currentVariation
                                                          .item.manufacturer
                                                          .externalName
                                                      )
                                                    }
                                                  })
                                            ]
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.hasPrimaryVariationSelector
                            ? _c(
                                "div",
                                { staticClass: "mt-3" },
                                [_c("variation-select")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c("item-bundle", {
                                attrs: {
                                  "bundle-type":
                                    _vm.currentVariation.variation.bundleType,
                                  "bundle-components":
                                    _vm.currentVariation.bundleComponents
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("before-price"),
                          _vm._v(" "),
                          _vm.currentVariation.filter.isSalable &&
                          _vm.variationGroupedProperties.length
                            ? _c("div", [_c("order-property-list")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _c("graduated-prices"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "fs-pricing-availability d-flex w-100 justify-content-between align-items-end"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-availability d-flex flex-wrap align-items-center"
                                },
                                [
                                  _c("item-availability"),
                                  _vm._v(" "),
                                  _vm.availabilityDisplayText
                                    ? _c("span", {
                                        staticClass:
                                          "pl-0 pl-lg-2 mb-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small",
                                        class:
                                          "availability-" +
                                          _vm.getDataField(
                                            "variation.availability.id"
                                          ),
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.availabilityDisplayText
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-shipping-meta d-flex w-100 justify-content-between align-items-center mt-1"
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "shipping small text-muted",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "HuGVueTheme::SingleItemTheme.Shipping"
                                            )
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-price text-right d-flex flex-column justify-content-end align-items-end"
                                },
                                [
                                  _vm.savingMoneyPercent > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "fs-savings-text mb-2 font-weight-bold"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Du sparst " +
                                              _vm._s(
                                                Math.floor(
                                                  _vm.savingMoneyPercent
                                                )
                                              ) +
                                              "%\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("item-price", {
                                    attrs: {
                                      "show-cross-price":
                                        _vm.isRecommendedPriceActive
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-price-meta d-flex w-100 justify-content-end align-items-center mt-1"
                                    },
                                    [
                                      _vm.$store.state.basket.data
                                        .shippingCountryId === 1
                                        ? [
                                            _c("span", {
                                              staticClass:
                                                "vat small id-1 text-muted",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$translate(
                                                    "HuGVueTheme::SingleItemTheme.Vat"
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        : [
                                            _c("span", {
                                              staticClass:
                                                "vat small id-else text-muted excl",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$translate(
                                                    "HuGVueTheme::SingleItemTheme.ExclVat"
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hydrated
                            ? _c(
                                "div",
                                { staticClass: "d-flex justify-content-end" },
                                [_vm._m(2)]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("after-price"),
                          _vm._v(" "),
                          _c("div", { staticClass: "fs-button" }, [
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("before-add-to-basket")],
                              2
                            ),
                            _vm._v(" "),
                            _vm.currentVariation.item.itemType === "set"
                              ? _c(
                                  "div",
                                  { staticClass: "alert alert-info w-100" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemSetInfo"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              : _c("div", { staticClass: "col-12 my-3 px-0" }, [
                                  _c("div", {
                                    ref: "buyboxCtaSentinel",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { ref: "buyboxCta" },
                                    [
                                      _c("add-to-basket", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id,
                                          "is-salable":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-children":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .hasActiveChildren,
                                          "interval-quantity":
                                            _vm.currentVariation.variation
                                              .intervalOrderQuantity || 1,
                                          "minimum-quantity":
                                            _vm.currentVariation.variation
                                              .minimumOrderQuantity,
                                          "maximum-quantity":
                                            !!_vm.currentVariation.variation
                                              .maximumOrderQuantity &&
                                            _vm.currentVariation.variation
                                              .maximumOrderQuantity > 0
                                              ? _vm.currentVariation.variation
                                                  .maximumOrderQuantity
                                              : null,
                                          "order-properties": _vm.currentVariation.properties.filter(
                                            function(prop) {
                                              return prop.property
                                                .isOderProperty
                                            }
                                          ),
                                          "has-order-properties":
                                            _vm.currentVariation
                                              .hasOrderProperties,
                                          "has-required-order-property":
                                            _vm.currentVariation
                                              .hasRequiredOrderProperty,
                                          "use-large-scale": false,
                                          "show-quantity": true,
                                          "item-url": _vm._f("itemURL")(
                                            _vm.currentVariation
                                          ),
                                          "is-variation-selected":
                                            _vm.isVariationSelected &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-price": _vm._f(
                                            "hasItemDefaultPrice"
                                          )(_vm.currentVariation)
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("after-add-to-basket")],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm._t("additional-content-after-add-to-basket"),
                          _vm._v(" "),
                          _vm._t("additional-content-after-vat")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn btn-block border-radius font-weight-bold p-0 px-3 px-md-0"
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0);",
                                id: "shareToggle",
                                onclick: "toggleShareDiv()"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-share-alt float-left mr-2",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::SingleItemTheme.ShareButton"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(3)
                        ]
                      ),
                      _vm._v(" "),
                      _vm.getMyColorPropertyValue
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "fs-my-color-property px-3 px-md-0 mb-2"
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Farbe:")
                              ]),
                              _vm._v(" " + _vm._s(_vm.getMyColorPropertyValue))
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("fs-color"),
                      _vm._v(" "),
                      _vm._t("fs-size-button"),
                      _vm._v(" "),
                      _vm.hydrated
                        ? _c("easycredit-widget", {
                            staticClass: "d-none",
                            attrs: {
                              "webshop-id": "1.de.12094.1",
                              amount:
                                _vm.currentVariation.prices.default.price.value,
                              extended: "true",
                              "disable-flexprice": "false"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$translate(
                        "HuGVueTheme::SingleItemTheme.itemBannerImage"
                      ) !== ""
                        ? _c(
                            "a",
                            {
                              staticClass: "item-banner",
                              attrs: {
                                href: _vm.$translate(
                                  "HuGVueTheme::SingleItemTheme.itemBannerLink"
                                )
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "img-fluid mt-2 mb-3",
                                attrs: {
                                  src: _vm.$translate(
                                    "HuGVueTheme::SingleItemTheme.itemBannerImage"
                                  ),
                                  alt: _vm.$translate(
                                    "HuGVueTheme::SingleItemTheme.itemBannerAlt"
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variationProperties &&
                      _vm.currentVariation.variationProperties.length > 0
                        ? _vm._l(_vm.getKeyFactsProperties, function(
                            variationPropertyGroups
                          ) {
                            return _c(
                              "div",
                              { key: variationPropertyGroups.id },
                              [
                                _c("p", {
                                  staticClass:
                                    "h4 font-weight-bold mb-3 px-3 px-md-0",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "HuGVueTheme::SingleItemTheme.KeyFactsHeadline"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "list-unstyled m-0 p-0 px-3 px-md-0 mb-5"
                                  },
                                  _vm._l(
                                    variationPropertyGroups.properties,
                                    function(variationProperty) {
                                      return _c(
                                        "li",
                                        {
                                          key: variationProperty.id,
                                          staticClass: "d-flex mb-3"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check mr-3 mt-1"
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "font-weight-bold",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                variationProperty.values.value
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variationProperties &&
                      _vm.currentVariation.variationProperties.length > 0
                        ? _vm._l(_vm.getVideoProperties, function(
                            variationPropertyGroups
                          ) {
                            return _c(
                              "div",
                              {
                                key: variationPropertyGroups.id,
                                staticClass:
                                  "px-3 px-md-0 mb-3 d-flex d-md-none"
                              },
                              [
                                _c("button", {
                                  staticClass:
                                    "btn btn-primary fs-video-btn border-radius font-weight-bold d-inline-flex align-items-center w-100 justify-content-center",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "modal",
                                    "data-target": "#product-video"
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "HuGVueTheme::SingleItemTheme.ModalButtonText"
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.getEanBarcodes, function(barcodes) {
                        return _c(
                          "p",
                          {
                            key: barcodes.id,
                            staticClass: "ml-3 ml-md-0 mb-0"
                          },
                          [
                            _c("span", [_vm._v("EAN: ")]),
                            _vm._v(_vm._s(barcodes.code))
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.currentVariation.variation.number != ""
                        ? [
                            _c("p", { staticClass: "ml-3 ml-md-0 mb-0" }, [
                              _c("span", [_vm._v("SKU: ")]),
                              _vm._v(
                                _vm._s(_vm.currentVariation.variation.number)
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "single container-fluid bg-primary pt-3",
              attrs: { id: "itemnav" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "container-max p-0 position-relative single-nav-hints",
                  class: {
                    "is-overflowing": _vm.singleNavIsOverflowing,
                    "can-scroll-left": _vm.singleNavCanScrollLeft,
                    "can-scroll-right": _vm.singleNavCanScrollRight
                  }
                },
                [
                  _c(
                    "ul",
                    {
                      ref: "singleNav",
                      staticClass:
                        "single-nav list-unstyled d-flex justify-content-around m-2"
                    },
                    [
                      _vm._t("single-navigation"),
                      _vm._v(" "),
                      _vm.documentLinks.length
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "d-flex mr-4 pb-3 justify-content-around"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-white font-weight-bold scroll",
                                  attrs: { href: "#documents" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "HuGVueTheme::SingleItemTheme.NavigationDocuments"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "single container-max page-content addinfo mt-5 mb-3"
            },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-6 order-1 order-lg-1 d-flex flex-wrap align-self-start"
                  },
                  [
                    _c("div", { staticClass: "w-100 order-1 order-lg-1" }, [
                      _c("p", {
                        staticClass: "m-0",
                        attrs: { id: "itemDesc" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-description-container mb-45" },
                        [
                          _c("div", { staticClass: "item-description" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.description
                                )
                              }
                            })
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-100 order-2 order-lg-2" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-gray p-3 mb-45 border-radius js-show-more",
                          attrs: {
                            id: "techData",
                            "data-show-more-height": "250"
                          }
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "h4 font-weight-bold mb-3 mb-md-0" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemTechnicalData"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "mt-3 js-show-more-content",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.technicalData
                              )
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 order-3 order-lg-3" },
                      [
                        [
                          _vm.filteredVariationPropertyGroups.length &&
                          _vm.getFAQProperties.length
                            ? _c(
                                "div",
                                [
                                  _c("p", {
                                    staticClass: "m-0",
                                    attrs: { id: "faq" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.getFAQProperties, function(
                                    variationProperty
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: variationProperty.id,
                                        staticClass:
                                          "fs-faq bg-gray p-3 mb-45 border-radius"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "h4 font-weight-bold mb-3"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HuGVueTheme::SingleItemTheme.NavigationFAQ"
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        variationProperty.values.value
                                          ? _c("div", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    variationProperty.values
                                                      .value
                                                  )
                                                }
                                              })
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 order-4 order-lg-4" },
                      [
                        [
                          _vm.filteredVariationPropertyGroups.length &&
                          _vm.getMontageProperties.length
                            ? _c(
                                "div",
                                [
                                  _c("p", {
                                    staticClass: "m-0",
                                    attrs: { id: "montage" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.getMontageProperties, function(
                                    variationProperty
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: variationProperty.id,
                                        staticClass:
                                          "fs-montage bg-gray p-3 mb-45 border-radius js-show-more",
                                        attrs: {
                                          "data-show-more-height": "250"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "h4 font-weight-bold mb-3"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HuGVueTheme::SingleItemTheme.NavigationMontage"
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        variationProperty.values.value
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "js-show-more-content"
                                              },
                                              [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      variationProperty.values
                                                        .value
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-6 order-2 order-lg-2 px-0 px-lg-3 d-flex flex-wrap align-self-start"
                  },
                  [
                    _c("div", { staticClass: "w-100 order-1 order-lg-1" }, [
                      _c(
                        "div",
                        { staticClass: "fs-xselling" },
                        [_vm._t("cross-selling-accessory")],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-100 order-2 order-lg-2" }, [
                      _c(
                        "div",
                        { staticClass: "fs-xselling" },
                        [_vm._t("cross-selling-similar")],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 order-3 order-lg-3" },
                      [
                        _vm.documentLinks.length
                          ? [
                              _c("p", {
                                staticClass: "m-0",
                                attrs: { id: "documents" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-documents artikeldetailseite-montage-wrapper bg-gray p-3 mb-45 border-radius"
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "h4 font-weight-bold mb-3" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "HuGVueTheme::SingleItemTheme.NavigationDocuments"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.documentLinks, function(
                                    documentLink
                                  ) {
                                    return _c(
                                      "a",
                                      {
                                        key: documentLink.url,
                                        staticClass: "adm-doc-link",
                                        attrs: {
                                          href: documentLink.url,
                                          target: "_blank",
                                          rel: "noopener"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "adm-doc-icon",
                                          attrs: {
                                            src:
                                              "https://cdn02.plentymarkets.com/6nqf4rd4jwp6/frontend/Hersteller_Logos/Logo_content/hug24-logo-pdf-dokument.png",
                                            alt: "",
                                            loading: "lazy"
                                          },
                                          on: {
                                            error: _vm.showDocumentIconFallback
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-file-pdf-o adm-doc-icon d-none",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(documentLink.title))
                                        ])
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-100 order-4 order-lg-4" }, [
                      _c(
                        "section",
                        {
                          staticClass:
                            "fs-guarantees bg-gray p-3 mb-45 border-radius"
                        },
                        [
                          _c(
                            "h2",
                            { staticClass: "h4 font-weight-bold mb-3" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::SingleItemTheme.GuaranteeHeadline"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "fs-guarantees__labels" },
                            _vm._l(_vm.guaranteeLabels, function(label) {
                              return _c(
                                "a",
                                {
                                  key: label.url,
                                  staticClass: "fs-guarantees__preview",
                                  attrs: {
                                    href: label.url,
                                    target: "_blank",
                                    rel: "noopener",
                                    "aria-haspopup": "dialog",
                                    "aria-label": label.title
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openGuaranteeLabel(
                                        label,
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  !_vm.guaranteeImageErrors.includes(label.url)
                                    ? _c("img", {
                                        attrs: {
                                          src: label.url,
                                          alt: label.title,
                                          loading: "lazy",
                                          decoding: "async"
                                        },
                                        on: {
                                          error: function($event) {
                                            return _vm.markGuaranteeImageError(
                                              label.url
                                            )
                                          }
                                        }
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "fs-guarantees__error" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(label.title) +
                                              ":\n                    " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "HuGVueTheme::SingleItemTheme.GuaranteeImageError"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-100 order-5 order-lg-5" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "fs-contact bg-gray p-3 mb-45 border-radius"
                        },
                        [
                          _c("p", { staticClass: "h4 font-weight-bold mb-3" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "HuGVueTheme::SingleItemContact.ContactHeadline"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "HuGVueTheme::SingleItemContact.ContactText"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "HuGVueTheme::SingleItemContact.ContactTelefon"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::SingleItemContact.ContactMail"
                                  )
                                ) +
                                "\n                "
                            ),
                            _c(
                              "a",
                              { attrs: { href: _vm.contactMailtoHref } },
                              [_vm._v(_vm._s(_vm.contactRecipientEmail))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "fs-contact-link" }, [
                            _c("p", { staticClass: "mb-1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::SingleItemContact.ContactLinkTo"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-inline btn-primary btn-appearance border-radius mt-1",
                                attrs: { href: _vm.contactMailtoHref }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$translate(
                                        "HuGVueTheme::SingleItemContact.ContactLinkButton"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 order-6 order-lg-6" },
                      [
                        [
                          _vm.filteredVariationPropertyGroups.length &&
                          _vm.getRangeProperties.length
                            ? _c(
                                "div",
                                [
                                  _c("p", {
                                    staticClass: "m-0",
                                    attrs: { id: "range" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.getRangeProperties, function(
                                    variationProperty
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: variationProperty.id,
                                        staticClass:
                                          "fs-range bg-gray p-3 mb-45 border-radius"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "h4 font-weight-bold mb-3"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HuGVueTheme::SingleItemTheme.NavigationRange"
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        variationProperty.values.value
                                          ? _c("div", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    variationProperty.values
                                                      .value
                                                  )
                                                }
                                              })
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 order-7 order-lg-7" },
                      [
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fs-manufacturer bg-gray p-3 mb-45 border-radius js-show-more",
                              attrs: { "data-show-more-height": "250" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "js-show-more-content" },
                                [
                                  _vm.filteredVariationPropertyGroups.length &&
                                  _vm.getManufacturerProperties.length
                                    ? _c(
                                        "div",
                                        [
                                          _c("p", {
                                            staticClass: "m-0",
                                            attrs: { id: "manufacturer" }
                                          }),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.getManufacturerProperties,
                                            function(variationProperty) {
                                              return _c(
                                                "div",
                                                { key: variationProperty.id },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "h4 font-weight-bold mb-3"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "HuGVueTheme::SingleItemTheme.NavigationManufacturer"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  variationProperty.values.value
                                                    ? _c("div", [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              variationProperty
                                                                .values.value
                                                            )
                                                          }
                                                        })
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isEuResponsibleTabShown
                                    ? _c("div", { staticClass: "my-4" }, [
                                        _c(
                                          "p",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemEuResponsiblePerson"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "p-0" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.responsibleName
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "p-0" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsibleStreet
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsibleHouseNo
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "p-0" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsiblePostCode
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.responsibleTown
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleCountryObject
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.currentVariation.item
                                                        .manufacturer
                                                        .responsibleCountryObject
                                                        .name
                                                    ) +
                                                    "\n                      "
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "p-0" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.responsibleEmail
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "p-0" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsiblePhoneNo
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "p-0" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsibleContactUrl
                                              )
                                            )
                                          ])
                                        ])
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      ],
                      2
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "trusted-anchor" } }, [
                _c("p", { staticClass: "h4 font-weight-bold mb-3" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "HuGVueTheme::SingleItemTheme.eTrustedHeadline"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("etrusted-widget", {
                      attrs: {
                        "data-etrusted-widget-id":
                          "wdg-d5a7ecfa-fc6e-4f0d-bd62-c0e1acc3b703"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container"),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fs-sticky-cart-slide" } }, [
                _vm.showStickyCart
                  ? _c(
                      "div",
                      {
                        staticClass: "fs-sticky-cart",
                        attrs: { "aria-label": "In den Warenkorb" }
                      },
                      [
                        _c("div", { staticClass: "fs-sticky-cart__inner" }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs-sticky-cart__thumb",
                              attrs: { "aria-hidden": "true" }
                            },
                            [
                              _vm.savingMoneyPercent > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-sticky-discount fs-discount-badge d-flex align-items-center justify-content-center text-white font-weight-bold position-absolute border-radius px-1 py-1"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              Math.floor(_vm.savingMoneyPercent)
                                            ) +
                                            "%"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentVariation.images &&
                              _vm.currentVariation.images.all &&
                              _vm.currentVariation.images.all.length
                                ? _c("img", {
                                    staticClass: "border-radius",
                                    attrs: {
                                      src:
                                        _vm.currentVariation.images.all[0]
                                          .urlPreview ||
                                        _vm.currentVariation.images.all[0]
                                          .urlMiddle ||
                                        _vm.currentVariation.images.all[0].url,
                                      alt: _vm._f("itemName")(
                                        _vm.currentVariation
                                      ),
                                      loading: "lazy"
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "fs-sticky-cart__meta" }, [
                            _c(
                              "div",
                              { staticClass: "fs-sticky-cart__title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "fs-sticky-cart__price" },
                              [
                                _c("item-price", {
                                  attrs: { "show-cross-price": false }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "fs-sticky-cart__cta" },
                            [
                              _c("add-to-basket", {
                                attrs: {
                                  "variation-id":
                                    _vm.currentVariation.variation.id,
                                  "is-salable":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-children":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter
                                      .hasActiveChildren,
                                  "interval-quantity":
                                    _vm.currentVariation.variation
                                      .intervalOrderQuantity || 1,
                                  "minimum-quantity":
                                    _vm.currentVariation.variation
                                      .minimumOrderQuantity,
                                  "maximum-quantity":
                                    !!_vm.currentVariation.variation
                                      .maximumOrderQuantity &&
                                    _vm.currentVariation.variation
                                      .maximumOrderQuantity > 0
                                      ? _vm.currentVariation.variation
                                          .maximumOrderQuantity
                                      : null,
                                  "order-properties": _vm.currentVariation.properties.filter(
                                    function(prop) {
                                      return prop.property.isOderProperty
                                    }
                                  ),
                                  "has-order-properties":
                                    _vm.currentVariation.hasOrderProperties,
                                  "has-required-order-property":
                                    _vm.currentVariation
                                      .hasRequiredOrderProperty,
                                  "use-large-scale": false,
                                  "show-quantity": false,
                                  "item-url": _vm._f("itemURL")(
                                    _vm.currentVariation
                                  ),
                                  "is-variation-selected":
                                    _vm.isVariationSelected &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-price": _vm._f("hasItemDefaultPrice")(
                                    _vm.currentVariation
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "guaranteeModal",
          staticClass: "modal fs-guarantee-modal",
          attrs: {
            tabindex: "-1",
            role: "dialog",
            "aria-modal": "true",
            "aria-hidden": "true",
            "aria-label": _vm.activeGuaranteeLabel
              ? _vm.activeGuaranteeLabel.title
              : _vm.$translate("HuGVueTheme::SingleItemTheme.GuaranteeHeadline")
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h3", { staticClass: "modal-title h5" }, [
                    _vm._v(
                      _vm._s(
                        _vm.activeGuaranteeLabel
                          ? _vm.activeGuaranteeLabel.title
                          : ""
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      ref: "guaranteeModalClose",
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": _vm.$translate(
                          "HuGVueTheme::SingleItemTheme.ModalClose"
                        )
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.activeGuaranteeLabel
                  ? _c("div", { staticClass: "modal-body text-center" }, [
                      _vm.guaranteeImageErrors.includes(
                        _vm.activeGuaranteeLabel.url
                      )
                        ? _c("p", { attrs: { role: "status" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::SingleItemTheme.GuaranteeImageError"
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        : _c("img", {
                            key: _vm.activeGuaranteeLabel.url,
                            staticClass: "fs-guarantee-modal__image",
                            attrs: {
                              src: _vm.activeGuaranteeLabel.url,
                              alt: _vm.activeGuaranteeLabel.title
                            },
                            on: {
                              error: function($event) {
                                return _vm.markGuaranteeImageError(
                                  $event.target.src
                                )
                              }
                            }
                          })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeGuaranteeLabel
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.activeGuaranteeLabel.url,
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$translate(
                                  "HuGVueTheme::SingleItemTheme.GuaranteeOpenOriginal"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex align-items-center text-warning",
        attrs: { "aria-hidden": "true" }
      },
      [
        _c("i", { staticClass: "fa fa-star mr-1" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-star mr-1" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-star mr-1" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-star mr-1" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-star mr-1" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "fs-easycredit-inline p-0",
        attrs: { type: "button", "data-ec-open": "" }
      },
      [
        _c("img", {
          attrs: {
            alt: "easyCredit Logo",
            src:
              "https://ratenkauf.easycredit.de/api/resource/webcomponents/v3/easycredit-components/assets/easycredit-supersign.svg"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "fs-easycredit-textlink" }, [
          _vm._v("Ratenzahlung mit easyCredit")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "share-buttons position-absolute border-radius px-3 px-md-0 mt-2",
        attrs: { id: "shareDiv" }
      },
      [
        _c(
          "a",
          {
            attrs: {
              id: "share-facebook",
              href: "javascript:void(0);",
              onclick: "share('facebook')"
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-facebook-official",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" Facebook ")
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              id: "share-whatsapp",
              href: "javascript:void(0);",
              onclick: "share('whatsapp')"
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-whatsapp",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" WhatsApp ")
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              id: "share-email",
              href: "javascript:void(0);",
              onclick: "share('email')"
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-envelope-o",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" Email ")
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }